import { Fragment } from "react";
import { Link } from "react-router-dom";
import { TruncateList } from "widgets";

import css from "../styles/Cell.module.css";

export interface TruncateLinkListItem {
  key: string;
  label: string;
  to: string;
  target?: string;
  rel?: string;
}

export interface TruncateLinkListProps {
  items: readonly TruncateLinkListItem[];
  separator?: string;
  ellipsis?: string;
  className?: string;
  style?: React.CSSProperties;
  linkClassName?: string;
}

export function TruncateLinkList({
  items,
  separator = ", ",
  ellipsis = "…",
  className,
  style,
  linkClassName,
  ...props
}: TruncateLinkListProps & React.HTMLAttributes<HTMLSpanElement>) {
  return (
    <TruncateList
      items={items}
      getLabel={(item) => item.label}
      separator={separator}
      ellipsis={ellipsis}
      className={className}
      style={style}
      {...props}
    >
      {({ hiddenCount, resultText, separator: computedSeparator, suffixText, visibleItems, visibleLabels }) => {
        if (visibleItems.length === 0) {
          return resultText;
        }

        return (
          <>
            {visibleItems.map((item, index) => (
              <Fragment key={item.key}>
                <Link to={item.to} target={item.target} rel={item.rel} className={linkClassName}>
                  {visibleLabels[index]}
                </Link>
                {index < visibleItems.length - 1 && computedSeparator}
              </Fragment>
            ))}
            {hiddenCount > 0 && <span className={css.affix}>{suffixText}</span>}
          </>
        );
      }}
    </TruncateList>
  );
}
